import { useEffect, useRef, useState } from "react";
import {
  Slider,
  Tooltip,
  Iconfont,
  useMessage,
} from "@eweadn-qiankun/shared-components";
import { useTranslation } from "react-i18next";
import { getElementXyData } from "./hooks/useAdvancedKeyState";
const mpt = (props: any) => {
  const { checkData, getAfterChangeData, getElementXy } = props;
  const wizardSteps = checkData?.wizard?.steps ?? [];
  const { t } = useTranslation();
  const toast = useMessage();
  const lastToastTimeRef = useRef(0);
  const [currentKeyRef, setCurrentKeyRef] = useState<any>(null); // 存储当前选中的元素引用

  const setKeyCheck = (key: number, e: any) => {
    const newCheckData = JSON.parse(JSON.stringify(checkData));
    newCheckData.triggerData.forEach((item: any) => {
      item.check = false;
    });
    newCheckData.triggerData[key].check = true;
    getAfterChangeData(newCheckData);
    setCurrentKeyRef(e.currentTarget); // 存储当前元素引用
    getElementXy(getElementXyData(e));
  };

  const setItineraryMinStartFn = (key: number, value: number) => {
    const newCheckData = JSON.parse(JSON.stringify(checkData));
    // 非首个按键时，需大于上一个按键的 value
    if (key > 0) {
      const prevValue = newCheckData.triggerData[key - 1].value;
      if (value <= prevValue) {
        const now = Date.now();
        if (now - lastToastTimeRef.current > 800) {
          lastToastTimeRef.current = now;
          toast.error(t("keyboard.advancedKey.mptModes.validate"));
        }
      }
    }
    newCheckData.triggerData[key].value = value;
    getAfterChangeData(newCheckData);
  };

  // 监听浏览器缩放（resize 事件）
  useEffect(() => {
    const handleResize = () => {
      if (currentKeyRef) {
        // 缩放时重新计算坐标
        getElementXy(getElementXyData({ target: currentKeyRef }), false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [currentKeyRef, getElementXy]); // 依赖当前元素引用

  return (
    <div className="advance-setting-box">
      <div className="advance-setting-box-header">
        <div className="advance-setting-box-header-title">
          {wizardSteps[1]?.titleKey ? t(wizardSteps[1].titleKey) : ""}
        </div>
        <div className="advance-setting-box-header-desc">
          {wizardSteps[1]?.descKey ? t(wizardSteps[1].descKey) : ""}
        </div>
      </div>
      <div className="operation-item operation-mpt">
        <div className="mpt-mode-box">
          <div className="mpt-dynamic-box">
            {checkData?.triggerData?.map((item: any, key: number) => (
              <div className="mpt-dynamic-item" key={key}>
                <div className="pressKey-box">
                  <div className="pressKey-text">
                    {t("keyboard.advancedKey.baseModesText.keys", {
                      num: key + 1,
                    })}
                  </div>
                  <Tooltip
                    text={
                      <div className="pressKey-tooltip">
                        <Iconfont
                          icon="warning"
                          className="pressKey-tooltip-icon"
                        />
                        <span>
                          {t(
                            "keyboard.advancedKey.baseModesText.selectKeyTips2"
                          )}
                        </span>
                      </div>
                    }
                    trigger="always"
                    placement="top"
                    usePortal
                    open={key === 0 && item.label === ""}
                  >
                    <div
                      className="pressKey"
                      onClick={(e) => setKeyCheck(key, e)}
                    >
                      {item.label || ""}
                    </div>
                  </Tooltip>
                </div>
                <div className="common-slider">
                  <div className="slider-item">
                    <div className="value">
                      <Slider
                        value={item.value}
                        onChange={(val: number) =>
                          setItineraryMinStartFn(key, val)
                        }
                        onChangeComplete={(val: number) =>
                          setItineraryMinStartFn(key, val)
                        }
                        min={0.01}
                        max={3.4}
                        step={0.01}
                        unit="mm"
                        showValue={true}
                      />
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
export default mpt;
